import { Controller, useFormContext } from "react-hook-form";
import styles from "../Cadastro.module.css";
import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { Lista } from "../../../../components/Lista/Lista";
import { HelperText } from "../../../../components/Errors/HelperText";
import { debounce } from 'lodash';
import { columnsSolCompartilhamentoPonto } from "./ListaPontos/Lista";
import servSolicitacaoCompartilhamento from "../../../../services/login/servSolicitacaoCompartilhamento";
import servSolicitacaoCompartilhamentoPontos from "../../../../services/login/servSolicitacaoCompartilhamentoPontos";
import {
  faExpand,
  faCompress,
  faMagnifyingGlassLocation,
} from "@fortawesome/free-solid-svg-icons";
import {
  GoogleMap,
  Marker,
  Polyline,
  InfoWindowF,
} from "@react-google-maps/api";
import servLogin from "../../../../services/login/servLogin";
import { BlueHoverButton } from "../../../../components/Inputs/BlueHoverButton";
import { yellow } from "@mui/material/colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AiOutlineLine } from "react-icons/ai";
import { FaRegCircleDot } from "react-icons/fa6";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import { faCheckDouble } from "@fortawesome/free-solid-svg-icons";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { faMap } from "@fortawesome/free-solid-svg-icons";
import { WhiteInput } from "../../../../components/Inputs/InputText";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Container,
  FormControl,
  Box,
  CircularProgress,
  InputLabel,
  Modal,
  Tooltip,
  Snackbar,
  Alert
} from "@mui/material";
import { FaDrawPolygon, FaHandPaper } from "react-icons/fa";
import { style as modalstyle } from "../../../../components/Loading/Loading";
import MapaDrawingManager from "../../../../components/MapaDrawing/MapaDrawingManager/MapaDrawingManager";
import { CiUndo } from "react-icons/ci";
import { GrSearch } from "react-icons/gr";
import { TbMapX } from "react-icons/tb";
import servConsultaDisponibilidade from "../../../../services/login/servConsultaDisponibilidade";
import servOcupante from "../../../../services/login/servOcupante";


const selectStyles = {
  control: (styles) => ({
    ...styles,
    marginTop: "15px",
    color: "#707070",
    backgroundColor: "#343434",
    borderRadius: "10px",
    padding: "3px",
  }),
  option: (styles, { isDisabled }) => {
    return {
      ...styles,
      backgroundColor: "#343434",
      color: "#707070",
      border: "none",
    };
  },
  input: (styles) => ({ ...styles, color: "#707070" }),
  singleValue: (styles) => ({ ...styles, color: "#707070" }),
  menuList: (styles) => ({ ...styles, backgroundColor: "#343434" }),
};

const Pontos = ({
  disableCampos,
  setOpen,
  setDisableAba,
  setErrorMessage,
  setPodeSalvar,
  situacao,
  methods,
  setOpenSuccess,
  setSuccessMessage,
  solicitacaoCompartilhamento,
  onKeyDown,
  isLoading,
  setIsLoading,
}) => {
  const {
    control,
    register,
    setValue,
    watch,
    setError,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const [solCompartilhamentoPonto, setSolCompartilhamentoPonto] = useState([]);
  const infoWindowRef = useRef(null);

  const [hoverTimeout, setHoverTimeout] = useState(null);
  const [poligono, setPoligono] = useState([]);
  const [openError, setOpenError] = useState(false);
  const [errorMessages, setErrorMessages] = useState("");
  const [modoAtivo, setModoAtivo] = useState("desenho");
  const [pontosMapa, setPontosMapa] = useState([]);
  const [redesMapa, setRedesMapa] = useState([]);
  const [searchAddress, setSearchAddress] = useState("");
  const drawingManagerRef = useRef(null);
  const polygonRef = useRef(null);
  const [hoveredDescricao, setHoveredDescricao] = useState(null);
  const polylinesRef = useRef([]);
  const polyRef = useRef(null);
  const [hoveredPosition, setHoveredPosition] = useState(null);
  const [drawingManagerKey, setDrawingManagerKey] = useState(Date.now());
  const [editavel, setEditavel] = useState(false);
  const [situacaoRevisao, setSituacaoRevisao] = useState(false);
  const [isLegenda, setIsLegenda] = useState(true);
  const mapRef = useRef(null);
  const circlesRef = useRef(new Map());
  const zoomAnimationFrame = useRef(null);
  const [currentZoom, setCurrentZoom] = useState(12);
  const [pontosMarcadosOcupacao, setPontosMarcadosOcupacao] = useState(false);
  const sidebarOpen = useSelector((state) => state.sidebar.sidebarOpen);
  const drawerWidth = sidebarOpen ? 250 : 72;
  const [coordenadasLatLong, setCoordenadasLatLong] = useState({
    lat: -28.67,
    lng: -49.37,
  });
  const [showDrawing, setShowDrawing] = useState(false);
  const [markerPosition, setMarkerPosition] = useState(coordenadasLatLong);
  const [mapaLoaded, setMapaLoaded] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [pontos, setPontos] = useState(null);
  const [selectedMarkers, setSelectedMarkers] = useState([]);
  const [openDialogMessageClearMap, setOpenDialogMessageClearMap] = useState(false);
  const [parametros, setParametros] = useState({
    DisponibilizaMapas: 0,
    QtdeMaximaDePontosPoste: 0,
    Id: "",
  });
  const containerStyle = {
    width: isFullScreen ? "100%" : "380px",
    height: isFullScreen ? "100%" : "300px",
    borderRadius: "10px",
  };

  const isMarkerSelected = (index) => {
    return selectedMarkers.some(marker => marker.Codigo === index);
  };

  const fecharMapa = () => {
    setIsLegenda(true);
    setIsFullScreen(false);
  };

  const handleMarkerClick = (ponto) => {
    setSelectedMarkers(prev => {
      const isSelected = prev.some(marker => marker.Codigo === ponto.Codigo);

      if (isSelected) {
        return prev.filter(marker => marker.Codigo !== ponto.Codigo);
      } else {
        return [...prev, { ...ponto }];
      }

    });
  };

  const handleCloseDialog = () => {
    setOpenDialogMessageClearMap(false);
  };

  useEffect(() => {
    console.log("Selected markers changed:", selectedMarkers);
  }, [selectedMarkers]);

  const getCircleRadius = (zoom) => {
    const baseRadius = 16;
    const zoomFactor = Math.pow(2, 15 - zoom);
    return Math.max(12, baseRadius * zoomFactor);
  };

  useEffect(() => {
    if (!mapRef.current || !circlesRef.current) return;

    const updateCircleSizes = debounce(() => {
      const newZoom = mapRef.current.getZoom();
      if (newZoom === currentZoom) return;
      setCurrentZoom(newZoom);

      const newRadius = getCircleRadius(newZoom);

      circlesRef.current.forEach((circle) => {
        if (circle?.setRadius) {
          circle.setRadius(newRadius);
        }
      });
    }, 100);

    const zoomListener = mapRef.current.addListener('zoom_changed', updateCircleSizes);

    updateCircleSizes();

    return () => {
      if (zoomListener) {
        window.google.maps.event.removeListener(zoomListener);
      }
    };
  }, [mapaLoaded]);

  const getColorForType = (tipo) => {
    const colorMap = {
      1: "#FFFF00",
      2: "#008000",
      3: "#FF0000",
      4: "#FF8C00",
      5: "#8B0000",
    };

    return colorMap[tipo] || "#3e3e3e";
  };

  useEffect(() => {
    const situacaoEditaveisDigitacao = [0, 2];
    const situacaoEditaveisRevisao = [0, 2];

    setEditavel(!situacaoEditaveisDigitacao.includes(situacao));
    setSituacaoRevisao(!situacaoEditaveisRevisao.includes(situacao));
  }, [situacao]);

  useEffect(() => {
    recuperarParametros();
    recuperarCidadePadrao();
    recuperarPontos();
  }, [mapaLoaded]);

  async function recuperarParametros() {
    try {
      const response = await servConsultaDisponibilidade.BuscarParametros();

      if (response && response.Content.length) {
        setParametros(response.Content[0]);
      }
    } catch (err) {
      console.log(err);
    }
  }

  const handleSelecionarTudo = () => {
    if (!pontos || pontos.length === 0) {
      return;
    }

    setSelectedMarkers(
      pontos.map(ponto => ({
        ...ponto,
        index: ponto.Codigo,
      }))
    );
  };

  async function recuperarPontos() {
    try {
      setIsLoading(true);
      if (!solicitacaoCompartilhamento) {
        setErrorMessage("Pontos da Solicitação de compartilhamento não encontrados.");
        setOpen(true);
        return;
      }

      const response = await servSolicitacaoCompartilhamentoPontos.listar(
        solicitacaoCompartilhamento
      );

      const codigoOcupante = methods.getValues("codigoOcupante")?.value;

      if (response && response.Content.length) {
        const listPoints = [];
        const data = response.Content;

        methods.setValue("qtdePontos", response.Total);
        await data.forEach((item) => {
          listPoints.push({
            id: listPoints.length + 1,
            Id: item.Id,
            Codigo: item.CodigoPontoSc,
            Descricao: item.DescricaoPontoSc,
            Lat: item.Latitude,
            Lng: item.Longitude,
            TemOcupacao: item.TemOcupacao,
            QtdeUsoMutuo: item.QtdeUsoMutuo,
            UsosMutuos: item.UsosMutuos || []
          });
        });

        const todosComOcupacao = listPoints.every((ponto) => ponto.TemOcupacao === 1);

        if (todosComOcupacao) {
          setPontosMarcadosOcupacao(true);
        } else {
          setPontosMarcadosOcupacao(false);
        }

        setIsLoading(false);
        setSolCompartilhamentoPonto(listPoints);
        setSelectedMarkers([]);
        setPontosMapa(
          listPoints.map((p) => ({
            Codigo: p.Codigo,
            Lat: Number(p.Lat),
            Lng: Number(p.Lng),
            Descricao: p.Descricao,
            QtdeUsoMutuo: p.QtdeUsoMutuo || 0,
            UsosMutuos: p.UsosMutuos || []
          }))
        );
        setCoordenadasLatLong({
          lat: listPoints[0].Lat,
          lng: listPoints[0].Lng
        });
        ativarModoMao();
      } else {
        setSolCompartilhamentoPonto([]);
        setSelectedMarkers([]);
        setIsLoading(false);
        methods.setValue("qtdePontos", 0);
      }
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  }

  const handleZoomChanged = () => {
    if (!mapRef.current) return;

    const newZoom = mapRef.current.getZoom();
    setCurrentZoom(newZoom);

    const newRadius = getCircleRadius(newZoom);

    circlesRef.current.forEach((circle) => {
      if (circle && circle.setRadius) {
        circle.setRadius(newRadius);
      }
    });
  };

  const handleMarcarTodasTemOcupacoes = async () => {
    const dtoGuidsPontos = [];

    solCompartilhamentoPonto.forEach((ponto) => {
      dtoGuidsPontos.push(ponto.Id);
    });

    try {
      await servSolicitacaoCompartilhamentoPontos.MarcarTemOcupacao(
        dtoGuidsPontos
      );
      setOpenSuccess(true);
      setSuccessMessage("Todas as ocupações foram marcadas com sucesso.");
      recuperarPontos();
    } catch (error) {
      console.error("Erro ao marcar todas as ocupações:", error);
    }
  };

  const handleDesmarcarTodasTemOcupacoes = async () => {
    const dtoGuidsPontos = [];

    solCompartilhamentoPonto.forEach((ponto) => {
      dtoGuidsPontos.push(ponto.Id);
    });

    try {
      await servSolicitacaoCompartilhamentoPontos.DesmarcarTemOcupacao(
        dtoGuidsPontos
      );
      setOpenSuccess(true);
      setSuccessMessage("Todas as ocupações foram desmarcadas com sucesso.");
      recuperarPontos();
    } catch (error) {
      console.error("Erro ao desmarcar todas as ocupações:", error);
    }
  }

  const ativarModoDesenho = () => {
    if (polyRef.current) {
      polyRef.current.setMap(null);
      polyRef.current = null;
    }

    setModoAtivo("desenho");
  };

  const handleSearch = async () => {
    if (!searchAddress.trim()) {
      setErrorMessage("Por favor, insira um endereço para buscar.");
      setOpen(true);
      return;
    }

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode(
      { address: searchAddress, region: "BR" },
      (results, status) => {
        if (status === "OK") {
          const location = results[0].geometry.location;
          const newPosition = { lat: location.lat(), lng: location.lng() };

          setMarkerPosition(newPosition);
          setCoordenadasLatLong(newPosition);
          setValue("CoordenadaX", newPosition.lng);
          setValue("CoordenadaY", newPosition.lat);

          if (mapRef.current) {
            mapRef.current.setZoom(18);
            mapRef.current.panTo(newPosition);
          }
        } else {
          setErrorMessages("Erro ao buscar endereço.");
          setOpenError(true);
        }
      }
    );
  };

  const ativarModoMao = () => {
    setModoAtivo("mao");
  };

  const handleUndoPonto = () => {
    if (polyRef.current) {
      const path = polyRef.current.getPath();
      if (path.getLength() > 0) {
        path.pop();
      }

      const updatedCoordenadas = path.getArray().map((latLng, index) => ({
        NumeroPonto: index + 1,
        Latitude: latLng.lat().toString(),
        Longitude: latLng.lng().toString(),
      }));

      if (updatedCoordenadas.length > 0) {
        updatedCoordenadas.push({
          NumeroPonto: updatedCoordenadas.length + 1,
          Latitude: updatedCoordenadas[0].Latitude,
          Longitude: updatedCoordenadas[0].Longitude,
        });
      }

      setPoligono(updatedCoordenadas);
    }
  };

  function handleLimparMapa() {
    if (polygonRef.current) {
      polygonRef.current.setMap(null);
      polygonRef.current = null;
    }

    if (drawingManagerRef.current) {
      drawingManagerRef.current.setMap(null);
      drawingManagerRef.current.setDrawingMode(null);
    }

    if (polyRef.current) {
      polyRef.current.setMap(null);
      polyRef.current = null;
    }

    setPoligono([]);
    setHoveredDescricao(null);
    setHoveredPosition(null);
    setPontosMapa([]);
    setPontos([]);
    setRedesMapa([]);
    setSelectedMarkers([]);

    polylinesRef.current.forEach((polyline) => polyline.setMap(null));
    polylinesRef.current = [];

    setDrawingManagerKey(Date.now());
    setModoAtivo("mao");
    handleCloseDialog();
  }

  const onClickSetFullscreenControl = () => {
    setIsFullScreen((prevState) => !prevState);
    setIsLegenda((prevState) => !prevState);
  };

  async function recuperarCidadePadrao() {
    try {
      const response = await servLogin.recuperarCidadePadrao();

      if (response?.Success) {
        const data = {
          lat: response.Content?.Latitude || -23.55052,
          lng: response.Content?.Longitude || -46.633309,
        };

        setCoordenadasLatLong(data);
        setShowDrawing(true);
      }
    } catch (err) {
      console.log(err);
    }
  }

  const handleCloseError = (event, reason) => {
    if (reason === 'clickaway') {
      setOpenError(false);
    }

    setOpenError(false);
  }

  async function handleDelete(record) {
    try {
      setIsLoading(true);
      const codigoPontoGuid = record.Id;
      const response = await servSolicitacaoCompartilhamentoPontos.RemoverPonto(
        codigoPontoGuid
      );
      if (response?.Success) {
        setOpenSuccess(true);
        setSuccessMessage("Ponto removido com sucesso.");
        recuperarPontos();
      } else {
        setErrorMessage(response?.Message || "Erro ao remover ponto.");
        setOpen(true);
      }
    } catch (err) {
      setErrorMessage("Erro ao remover ponto.");
      setOpen(true);
    } finally {
      setIsLoading(false);
    }
  }

  async function handleConsultarPontos(coordenadas) {
    try {
      if (!coordenadas) return;
      setIsLoading(true);

      const response = await servSolicitacaoCompartilhamento.BuscarPontos(coordenadas);
      const { Pontos, Redes } = response.Content;

      if (Pontos.length === 0 && Redes.length === 0) {
        setErrorMessage("Nenhum ponto encontrado");
        setOpen(true);
        setIsLoading(false);
        if (polyRef.current) { polyRef.current.setMap(null); polyRef.current = null; }
        return;
      }

      setPontos(prevPontos => {
        const prev = prevPontos || [];
        const rowsPontosIds = Pontos.map((row, index) => ({
          id: (prev.length || 0) + index + 1,
          ...row,
        }));
        return [...prev, ...rowsPontosIds];
      });
      setPontosMapa(prevPontos => [...prevPontos, ...Pontos]);
      setRedesMapa(prevRedes => [...prevRedes, ...Redes]);
      setIsLoading(false);

      if (polyRef.current) { polyRef.current.setMap(null); polyRef.current = null; }
    } catch (err) {
      if (polyRef.current) { polyRef.current.setMap(null); polyRef.current = null; }
      setErrorMessage(err?.response?.data?.Message);
      setOpen(true);
      setIsLoading(false);
    }
  }

  const handleInserirPontos = () => {
    if (!selectedMarkers || selectedMarkers.length === 0) {
      if (isFullScreen) {
        setErrorMessages("Nenhum ponto selecionado para inserir.");
        setOpenError(true);
        return;
      } else {
        setErrorMessage("Nenhum ponto selecionado para inserir.");
        setOpen(true);
        return;
      }
    }
    addPontosSolCompartilhamento(selectedMarkers);
  };

  async function addPontosSolCompartilhamento(selectedMarkers) {
    try {
      setIsLoading(true);
      const codigosExistentes = solCompartilhamentoPonto.map((p) =>
        String(p.Codigo)
      );
      const codeAnalise = methods.getValues("analise");
      const pontosParaInserir = selectedMarkers.filter(
        (p) => !codigosExistentes.includes(String(p.Codigo))
      );
      if (pontosParaInserir.length === 0) {
        if (isFullScreen) {
          setErrorMessages("Todos os pontos selecionados já foram inseridos.");
          setOpenError(true);
          setIsLoading(false);
          return;
        } else {
          setErrorMessage("Todos os pontos selecionados já foram inseridos.");
          setOpen(true);
          setIsLoading(false);
          return;
        }
      }

      const responseSave = await servSolicitacaoCompartilhamentoPontos.inserir(
        pontosParaInserir,
        solicitacaoCompartilhamento,
        codeAnalise
      );

      recuperarPontos();

      if (responseSave?.Success) {
        setOpenSuccess(true);
        setSuccessMessage("Pontos adicionados com sucesso.");
        recuperarPontos();
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setErrorMessage(responseSave?.Message || "Erro ao adicionar pontos.");
        setOpen(true);
      }

      if (isFullScreen) {
        setIsFullScreen(false);
        setIsLegenda(true);
        setPontos([]);
        handleLimparMapa();
      }
    } catch (err) {
      setErrorMessage("Erro ao adicionar pontos.");
      setIsLoading(false);
      setOpen(true);
    }
  }

  async function handleCheck(record) {
    try {
      setIsLoading(true);

      const updatedRecords = {
        ...record,
        TemOcupacao: record.TemOcupacao === 1 ? 0 : 1,
      };

      const response = await servSolicitacaoCompartilhamentoPontos.editar(
        updatedRecords,
        solicitacaoCompartilhamento
      );
      if (response?.Success) {
        setOpenSuccess(true);
        setSuccessMessage("Ponto atualizado com sucesso.");
        recuperarPontos();
      } else {
        setErrorMessage(response?.Message || "Erro ao atualizar ponto.");
        setOpen(true);
      }
    } catch (err) {
      setErrorMessage("Erro ao atualizar ponto.");
      setOpen(true);
    } finally {
      setIsLoading(false);
    }
  }

  const onClickSetPontosMapa = () => {
    if (!solCompartilhamentoPonto || solCompartilhamentoPonto.length === 0) {
      setErrorMessage("Nenhum ponto disponível para exibir no mapa.");
      setOpen(true);
      return;
    }

    setPontosMapa(
      solCompartilhamentoPonto.map((p) => ({
        Codigo: p.Codigo,
        Lat: Number(p.Lat),
        Lng: Number(p.Lng),
        Descricao: p.Descricao,
        QtdeUsoMutuo: p.QtdeUsoMutuo || 0,
      }))
    );

    setCoordenadasLatLong({
      lat: solCompartilhamentoPonto[0].Lat,
      lng: solCompartilhamentoPonto[0].Lng,
    });
  };

  const handleRemoverTodosPontos = async () => {
    try {
      setIsLoading(true);

      const response = await servSolicitacaoCompartilhamentoPontos.RemoverPontos(
        solicitacaoCompartilhamento
      );

      if (response?.Success) {
        setOpenSuccess(true);
        setSuccessMessage("Todos os pontos removidos com sucesso.");
        recuperarPontos();
      } else {
        setErrorMessage(response?.Message || "Erro ao remover pontos.");
        setOpen(true);
      }
    } catch (err) {
      setErrorMessage("Erro ao remover pontos.");
      setOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        style={{
          marginTop: "40px",
          width: "100%",
          display: "flex",
          alignItems: "start",
          justifyContent: "space-between",
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "20px",
              marginTop: "-20px",
            }}
          >
            <InputLabel
              sx={{
                color: "#b8b8b8",
                fontSize: "12px",
                fontWeight: 600,
                marginRight: "10px",
              }}
            >
              Informe aqui a localização no mapa
            </InputLabel>
            <Tooltip
              title="Necessário preencher o endereço conforme o exemplo para maior assertividade do mapa."
              arrow
            >
              <div style={{ color: yellow[700], cursor: "pointer" }}>
                <FontAwesomeIcon icon={faCircleExclamation} />
              </div>
            </Tooltip>
          </div>
          <div
            style={{
              marginLeft: "20px",
              width: "100%",
            }}
          >
            <div
              style={{
                width: "92%",
                display: "flex",
                alignItems: "center",
              }}
            >
              <WhiteInput
                type="text"
                placeholder="Ex: Rua Visc. de Cairú, 630, Criciúma - SC"
                className="search-input"
                disabled={editavel}
                style={{
                  flex: 1,
                  color: "white",
                  fontSize: "16px",
                  width: "340px",
                }}
                value={searchAddress}
                onChange={(e) => setSearchAddress(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearch();
                  }
                }}
              />
              <BlueHoverButton
                onClick={handleSearch}
                disabled={editavel}
                style={{
                  background: "#8166F5",
                  color: "white",
                  height: "45px",
                  borderRadius: "0px 10px 10px 0px",
                  border: "none",
                  borderLeft: "none",
                  padding: "0px",
                  minWidth: "44px",
                }}
              >
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </BlueHoverButton>
            </div>
          </div>
          <div
            style={!isFullScreen ? {
              padding: "20px",
              display: "flex",
            } : {
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 9999,
              backgroundColor: "#1e1e1e",
            }}
          >
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={coordenadasLatLong}
              zoom={15}
              options={{
                fullscreenControl: false,
                gestureHandling: 'greedy',
                styles: [
                  {
                    featureType: "poi",
                    elementType: "labels",
                    stylers: [{ visibility: "off" }]
                  },
                  {
                    featureType: "poi.business",
                    stylers: [{ visibility: "off" }]
                  },
                  {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }]
                  }
                ],
              }}
              onLoad={(map) => {
                setMapaLoaded(true);
                mapRef.current = map;
                setCurrentZoom(map.getZoom());
              }}
              onZoomChanged={handleZoomChanged}
            >
              {pontosMapa.map((ponto, index) => {
                const isFull = parametros.QtdeMaximaDePontosPoste <= Number(ponto.QtdeUsoMutuo);
                const doOcupante = ponto.UsosMutuos?.includes(methods.getValues("codigoOcupante")?.CodigoUsoMutuo);

                let corDoPoste;

                if (isFull && doOcupante) {
                  corDoPoste = 5;
                } else if (isFull) {
                  corDoPoste = 3;
                } else if (doOcupante) {
                  corDoPoste = 4;
                } else {
                  corDoPoste = 2;
                }

                return (
                  <Marker
                    key={`${ponto.Lat}-${ponto.Lng}-${index}`}
                    position={{ lat: ponto.Lat, lng: ponto.Lng }}
                    icon={{
                      path: window.google.maps.SymbolPath.CIRCLE,
                      fillColor: getColorForType(corDoPoste),
                      fillOpacity: isMarkerSelected(ponto.Codigo) ? 1 : 0.8,
                      scale: isMarkerSelected(ponto.Codigo) ? 10 : 5,
                      strokeWeight: isMarkerSelected(ponto.Codigo) ? 2 : 1,
                      strokeColor: 'rgba(0, 0, 0, 0.4)',
                      strokeOpacity: 1,
                    }}
                    options={{
                      fillColor: getColorForType(corDoPoste),
                      fillOpacity: isMarkerSelected(ponto.Codigo) ? 1 : 0.9,
                      strokeColor: 'rgba(0, 0, 0, 0.4)',
                      strokeOpacity: isMarkerSelected(ponto.Codigo) ? 1 : 1,
                      zIndex: isMarkerSelected(ponto.Codigo) ? 2000 : 1000,
                      optimized: true
                    }}
                    onLoad={(circle) => {
                      if (!circlesRef.current) {
                        circlesRef.current = new Map();
                      }

                      circlesRef.current.set(ponto.Codigo, circle);
                    }}
                    onUnmount={() => {
                      if (circlesRef.current) {
                        circlesRef.current.delete(ponto.Codigo);
                      }
                    }}
                    onMouseOut={() => {
                      setHoveredIndex(null);
                      setHoveredDescricao(null);
                      setHoveredPosition(null);
                    }}
                    onMouseOver={() => {
                      clearTimeout(hoverTimeout);
                      setHoveredIndex(index);
                      setHoveredDescricao({
                        Codigo: ponto.Codigo,
                        QtdeEmUso: ponto.QtdeUsoMutuo,
                        QtdeEmAnalise: ponto.QtdeEmAnalise || "Não possui",
                        Descricao: ponto.Descricao,
                        Lat: ponto.Lat,
                        Lng: ponto.Lng,
                      });
                      setHoveredPosition({
                        lat: ponto.Lat + 0.0001,
                        lng: ponto.Lng,
                      });
                    }}
                    onClick={() => handleMarkerClick(ponto)}
                  />
                );
              })}

              {!isLegenda ? (
                <>
                  <div>
                    <Snackbar open={openError} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={2000} onClose={handleCloseError}>
                      <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
                        {errorMessages}
                      </Alert>
                    </Snackbar>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "20px",
                      width: "25%",
                      backgroundColor: "#343434",
                      borderRadius: "8px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                      zIndex: 2,
                      opacity: 0.9,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "8px 12px",
                      }}
                    >
                      <InputLabel
                        sx={{
                          color: "#b8b8b8",
                          fontSize: "12px",
                          fontWeight: 600,
                          marginRight: "10px",
                        }}
                      >
                        Informe aqui a localização no mapa
                      </InputLabel>
                      <Tooltip
                        title="Necessário preencher o endereço conforme o exemplo para maior assertividade do mapa."
                        arrow
                      >
                        <div style={{ color: yellow[700], cursor: "pointer" }}>
                          <FontAwesomeIcon icon={faCircleExclamation} />
                        </div>
                      </Tooltip>

                      <BlueHoverButton
                        onClick={() => setIsLegenda(true)}
                        className="red-hover-button"
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                          color: "#fff",
                          padding: "6px",
                          borderRadius: "8px",
                          cursor: "pointer",
                          whiteSpace: "nowrap",
                          marginLeft: "160px",
                        }}
                        title="Fechar legenda"
                      >
                        <AiOutlineLine />
                      </BlueHoverButton>
                    </div>

                    <div
                      style={{
                        marginBottom: "10px",
                        display: "flex",
                        alignItems: "center",
                        padding: "8px 12px",
                      }}
                    >
                      <WhiteInput
                        type="text"
                        placeholder="Ex: Rua Visc. de Cairú, 630, Criciúma - SC"
                        className="search-input"
                        style={{
                          flex: 1,
                          color: "white",
                          fontSize: "16px",
                          width: "340px",
                        }}
                        value={searchAddress}
                        onChange={(e) => setSearchAddress(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSearch();
                          }
                        }}
                      />
                      <BlueHoverButton
                        onClick={handleSearch}
                        style={{
                          background: "#8166F5",
                          color: "white",
                          height: "45px",
                          borderRadius: "0px 10px 10px 0px",
                          border: "none",
                          borderLeft: "none",
                          padding: "0px",
                          minWidth: "44px",
                        }}
                      >
                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                      </BlueHoverButton>
                    </div>

                    <div style={{ marginLeft: "18px", padding: "10px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
                        <div style={{ width: 20, height: 20, backgroundColor: "#008000", borderRadius: "50%", flexShrink: 0 }} />
                        <span style={{ color: "#b8b8b8", fontSize: "14px", minWidth: "150px" }}>Disponível</span>
                        <span style={{ color: "#b8b8b8", fontSize: "14px", whiteSpace: "nowrap", marginLeft: "45px" }}>Rede Secundária</span>
                        <div style={{ width: 40, borderBottom: "3px solid #808080", flexShrink: 0 }} />
                      </div>

                      <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
                        <div style={{ width: 20, height: 20, backgroundColor: "#FF0000", borderRadius: "50%", flexShrink: 0 }} />
                        <span style={{ color: "#b8b8b8", fontSize: "14px", minWidth: "150px" }}>Indisponível</span>
                        <span style={{ color: "#b8b8b8", fontSize: "14px", whiteSpace: "nowrap", marginLeft: "45px" }}>Rede Primária</span>
                        <div style={{ width: 40, borderBottom: "3px solid black", flexShrink: 0, marginLeft: "18px" }} />
                      </div>

                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div style={{ width: 20, height: 20, backgroundColor: "#FF8C00", borderRadius: "50%", flexShrink: 0 }} />
                        <span style={{ color: "#b8b8b8", fontSize: "14px", minWidth: "150px", whiteSpace: "nowrap" }}>
                          Em uso pelo ocupante
                        </span>
                      </div>

                      <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "12px" }}>
                        <div style={{ width: 20, height: 20, backgroundColor: "#8B0000", borderRadius: "50%", flexShrink: 0 }} />
                        <span style={{ color: "#b8b8b8", fontSize: "14px", minWidth: "150px", whiteSpace: "nowrap" }}>
                          Indisponível (já utilizado pelo ocupante)
                        </span>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(3, 1fr)",
                        gap: "15px",
                        backgroundColor: "#1e1e1e",
                        width: "100%",
                        borderTop: "1px solid #444",
                        boxShadow: "inset 0 1px 0 rgba(255,255,255,0.05)",
                        marginTop: "12px",
                        borderRadius: "6px",
                        justifyContent: "space-between",
                        padding: "10px 8px",
                        opacity: 1,
                      }}
                    >

                      <Tooltip title="Inserir pontos" arrow>
                        <BlueHoverButton
                          onClick={handleInserirPontos}
                          disabled={editavel}
                          style={{
                            backgroundColor: "#000",
                            color: "#fff",
                            padding: "10px",
                            borderRadius: "6px",
                            border: "none",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          title="Inserir pontos"
                        >
                          <FontAwesomeIcon
                            icon={faFileExport}
                            style={{
                              fontSize: "18px",
                              color: editavel ? "rgba(0, 0, 0, 0.26)" : "white",
                            }}
                          />
                        </BlueHoverButton>
                      </Tooltip>
                      <Tooltip title="Selecionar tudo" arrow>
                        <BlueHoverButton
                          onClick={handleSelecionarTudo}
                          disabled={editavel}
                          style={{
                            backgroundColor: "#000",
                            color: "#fff",
                            padding: "10px",
                            borderRadius: "6px",
                            border: "none",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          title="Selecionar tudo"
                        >
                          <FaRegCircleDot />
                        </BlueHoverButton>
                      </Tooltip>
                      <Tooltip title="Modo desenho" arrow>
                        <BlueHoverButton
                          onClick={ativarModoDesenho}
                          className={modoAtivo === "desenho" ? "botao-ativo" : ""}
                          style={{
                            backgroundColor: "#000",
                            color: "#fff",
                            padding: "10px",
                            borderRadius: "6px",
                            border: "none",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          title="Desenho"
                        >
                          <FaDrawPolygon size={26} />
                        </BlueHoverButton>
                      </Tooltip>
                      {/* <Tooltip title="Desfazer" arrow>
                    <BlueHoverButton
                      onClick={handleUndoPonto}
                      style={{
                        backgroundColor: "#000",
                        color: "#fff",
                        padding: "10px",
                        borderRadius: "6px",
                        border: "none",
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                      }}
                      title="Desfazer último ponto"
                    >
                      <CiUndo size={26} />
                    </BlueHoverButton>
                  </Tooltip> */}
                      <Tooltip title="Modo mão" arrow>
                        <BlueHoverButton
                          onClick={ativarModoMao}
                          className={modoAtivo === "mao" ? "botao-ativo" : ""}
                          style={{
                            backgroundColor: "#000",
                            border: "none",
                            borderRadius: "6px",
                            padding: "10px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          title="Parar de desenhar"
                        >
                          <FaHandPaper size={26} />
                        </BlueHoverButton>
                      </Tooltip>
                      <Tooltip title="Limpar mapa" arrow>
                        <BlueHoverButton
                          onClick={() => setOpenDialogMessageClearMap(true)}
                          className="red-hover-button"
                          style={{
                            backgroundColor: "#000",
                            color: "#fff",
                            padding: "10px",
                            borderRadius: "6px",
                            border: "none",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                          }}
                          title="Limpar mapa"
                        >
                          <TbMapX size={26} />
                        </BlueHoverButton>
                      </Tooltip>
                      <Tooltip title="Fechar mapa" arrow>
                        <BlueHoverButton
                          onClick={fecharMapa}
                          className="red-hover-button"
                          style={{
                            backgroundColor: "#000",
                            color: "#fff",
                            padding: "10px",
                            borderRadius: "6px",
                            border: "none",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                          }}
                          title="Fechar mapa"
                        >
                          <FontAwesomeIcon
                            icon={faCompress}
                            style={{ color: "white" }}
                          />
                        </BlueHoverButton>
                      </Tooltip>
                    </div>
                  </div>
                </>
              ) : isFullScreen && (
                <div
                  style={{
                    position: "absolute",
                    top: 20,
                    right: 20,
                    zIndex: 1,
                  }}
                >
                  <BlueHoverButton
                    onClick={() => setIsLegenda(false)}
                    style={{
                      borderRadius: "22px",
                      border: "none",
                      cursor: "pointer",
                      padding: "10px 15px",
                    }}
                  >
                    <FontAwesomeIcon icon={faMap} style={{ color: "white" }} />
                    <span style={{ marginLeft: 8, color: "white" }}>
                      Abrir legenda
                    </span>
                  </BlueHoverButton>
                </div>
              )}

              {redesMapa
                .filter(
                  (rede) =>
                    rede && Array.isArray(rede.Path) && rede.Path.length >= 2
                )
                .map((rede, index) => (
                  <Polyline
                    key={`${rede.TipoRede}-${index}`}
                    path={rede.Path.map((c) => ({ lat: c.Lat, lng: c.Lng }))}
                    onLoad={(polyline) => {
                      polylinesRef.current = [...polylinesRef.current, polyline];
                    }}
                    options={{
                      strokeColor: rede.TipoRede === 1 ? "#000000" : "#808080",
                      strokeOpacity: 0.8,
                      strokeWeight: 3,
                      geodesic: true,
                    }}
                  />
                ))}

              {hoveredPosition && (
                <InfoWindowF
                  position={hoveredPosition}
                  zIndex={20}
                  options={{
                    pixelOffset: new window.google.maps.Size(0, -8),
                    disableAutoPan: true
                  }}
                  onLoad={(iw) => {
                    infoWindowRef.current = iw;

                    const intervalId = setInterval(() => {
                      const container = iw.getContent()?.parentElement?.parentElement;
                      if (container) {
                        clearInterval(intervalId);

                        const closeButton = container.querySelector('.gm-ui-hover-effect');
                        if (closeButton) closeButton.remove();

                        const header = document.createElement('div');
                        header.style.display = 'flex';
                        header.style.justifyContent = 'space-between';
                        header.style.alignItems = 'center';
                        header.style.padding = '10px 12px';
                        header.style.background = '#fff';
                        header.style.color = 'black';

                        const title = document.createElement('div');
                        title.style.fontWeight = 'bold';
                        title.style.margin = '0px';
                        title.style.fontSize = '14px';
                        title.textContent = `Poste: ${hoveredDescricao.Codigo}`;

                        header.appendChild(title);

                        const content = iw.getContent();
                        if (content) {
                          content.insertBefore(header, content.firstChild);
                        }
                      }
                    }, 10);

                    return () => clearInterval(intervalId);
                  }}
                  onCloseClick={() => {
                    setHoveredDescricao(null);
                    setHoveredPosition(null);
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      padding: "12px",
                      minWidth: "200px",
                      backgroundColor: "white",
                      borderTop: ".4px dotted #e3e3e3",
                    }}
                  >
                    <div style={{ marginBottom: "6px" }}>
                      <span style={{ fontWeight: 500 }}>Característica: </span>
                      <span>{hoveredDescricao.Descricao}</span>
                    </div>
                    <div>
                      <span style={{ fontWeight: 500 }}>Em uso: </span>
                      <span>{hoveredDescricao.QtdeEmUso} / {parametros.QtdeMaximaDePontosPoste}</span>
                    </div>
                  </div>
                </InfoWindowF>
              )}

              {showDrawing && (
                <MapaDrawingManager
                  drawingManagerKey={drawingManagerKey}
                  polyRef={polyRef}
                  setPoligono={setPoligono}
                  drawingManagerRef={drawingManagerRef}
                  handleConsultarPontos={handleConsultarPontos}
                  setModoAtivo={setModoAtivo}
                  modoAtivo={modoAtivo}
                />
              )}
              <Modal open={isLoading}>
                <Box style={modalstyle}>
                  <CircularProgress color="inherit" />
                </Box>
              </Modal>
            </GoogleMap>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <span
              style={{
                color: "#b8b8b8",
                fontSize: "12px",
                display: "inline-block",
                width: "100%",
                textAlign: "center",
                marginLeft: "-8px"
              }}
            >
              <strong>Clique no botão ao lado do mapa para expandir a visualização. (⛶)</strong>
            </span>
          </div>

          <div style={{ marginLeft: "18px", padding: "10px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
              <div style={{ width: 20, height: 20, backgroundColor: "#008000", borderRadius: "50%", flexShrink: 0 }} />
              <span style={{ color: "#b8b8b8", fontSize: "14px", minWidth: "150px" }}>Disponível</span>
              <span style={{ color: "#b8b8b8", fontSize: "14px", whiteSpace: "nowrap", marginLeft: "15px" }}>Rede Secundária</span>
              <div style={{ width: 40, borderBottom: "3px solid #808080", flexShrink: 0 }} />
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
              <div style={{ width: 20, height: 20, backgroundColor: "#FF0000", borderRadius: "50%", flexShrink: 0 }} />
              <span style={{ color: "#b8b8b8", fontSize: "14px", minWidth: "150px" }}>Indisponível</span>
              <span style={{ color: "#b8b8b8", fontSize: "14px", whiteSpace: "nowrap", marginLeft: "15px" }}>Rede Primária</span>
              <div style={{ width: 40, borderBottom: "3px solid black", flexShrink: 0, marginLeft: "18px" }} />
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div style={{ width: 20, height: 20, backgroundColor: "#FF8C00", borderRadius: "50%", flexShrink: 0 }} />
              <span style={{ color: "#b8b8b8", fontSize: "14px", minWidth: "150px", whiteSpace: "nowrap" }}>
                Em uso pelo ocupante
              </span>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "12px" }}>
              <div style={{ width: 20, height: 20, backgroundColor: "#8B0000", borderRadius: "50%", flexShrink: 0 }} />
              <span style={{ color: "#b8b8b8", fontSize: "14px", minWidth: "150px", whiteSpace: "nowrap" }}>
                Indisponível (já utilizado pelo ocupante)
              </span>
            </div>
          </div>

        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            padding: "0px 20px 0px 0px",
            height: "380px",
          }}
        >
          {/* 
         <Tooltip title="Consultar disponibilidade" arrow>
          <BlueHoverButton
            onClick={handleConsultarPontos}
            disabled={editavel}
            style={{
              height: "40px",
              color: "#fff",
              borderRadius: "22px",
              border: "none",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
            title="Consultar disponibilidade"
          >
            <GrSearch
              size={18}
              style={{ color: editavel ? "rgba(0, 0, 0, 0.26)" : "white" }}
            />
          </BlueHoverButton>
        </Tooltip> */}

          <Tooltip title="Inserir pontos" arrow>
            <BlueHoverButton
              onClick={handleInserirPontos}
              disabled={editavel}
              style={{
                height: "40px",
                color: "#fff",
                borderRadius: "22px",
                border: "none",
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
              title="Inserir pontos"
            >
              <FontAwesomeIcon
                icon={faFileExport}
                style={{
                  fontSize: "18px",
                  color: editavel ? "rgba(0, 0, 0, 0.26)" : "white",
                }}
              />
            </BlueHoverButton>
          </Tooltip>

          <Tooltip title="Selecionar tudo" arrow>
            <BlueHoverButton
              onClick={handleSelecionarTudo}
              disabled={editavel}
              style={{
                height: "40px",
                color: "#fff",
                borderRadius: "22px",
                border: "none",
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
              title="Selecionar tudo"
            >
              <FaRegCircleDot />
            </BlueHoverButton>
          </Tooltip>

          <Tooltip title="Desenho" arrow>
            <BlueHoverButton
              onClick={ativarModoDesenho}
              disabled={editavel}
              className={
                !editavel && modoAtivo === "desenho" ? "botao-ativo" : ""
              }
              style={{
                color: "#fff",
                borderRadius: "22px",
                border: "none",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              title="Desenho"
            >
              <FaDrawPolygon
                size={24}
                style={{ color: editavel ? "rgba(0, 0, 0, 0.26)" : "white" }}
              />
            </BlueHoverButton>
          </Tooltip>

          {/* <Tooltip title="Desfazer" arrow>
          <BlueHoverButton
            onClick={handleUndoPonto}
            disabled={editavel}
            style={{
              color: "#fff",
              borderRadius: "22px",
              border: "none",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
            title="Desfazer último ponto"
          >
            <CiUndo
              size={24}
              style={{ color: editavel ? "rgba(0, 0, 0, 0.26)" : "white" }}
            />
          </BlueHoverButton>
        </Tooltip> */}

          <Tooltip title="Mão" arrow>
            <BlueHoverButton
              onClick={ativarModoMao}
              disabled={editavel}
              className={modoAtivo === "mao" ? "botao-ativo" : ""}
              style={{
                border: "none",
                borderRadius: "22px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              title="Parar de desenhar"
            >
              <FaHandPaper
                size={22}
                style={{ color: editavel ? "rgba(0, 0, 0, 0.26)" : "white" }}
              />
            </BlueHoverButton>
          </Tooltip>

          <Tooltip title="Limpar mapa" arrow>
            <BlueHoverButton
              onClick={() => setOpenDialogMessageClearMap(true)}
              disabled={editavel}
              className="red-hover-button"
              style={{
                borderRadius: "22px",
                border: "none",
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
            >
              <TbMapX
                size={22}
                style={{ color: editavel ? "rgba(0, 0, 0, 0.26)" : "white" }}
              />
            </BlueHoverButton>
          </Tooltip>

          <Tooltip title="Expandir mapa" arrow>
            <BlueHoverButton
              style={{
                borderRadius: "22px",
                backgroundColor: "#37208bff",
                border: "none",
                cursor: "pointer",
                whiteSpace: "nowrap",
                height: "36px",
              }}
              onClick={onClickSetFullscreenControl}
              disabled={editavel}
            >
              <FontAwesomeIcon
                icon={faExpand}
                style={{ color: editavel ? "rgba(0, 0, 0, 0.26)" : "white" }}
              />
            </BlueHoverButton>
          </Tooltip>

          <Tooltip title="Consultar pontos no mapa" arrow>
            <BlueHoverButton
              style={{
                borderRadius: "22px",
                border: "none",
                cursor: "pointer",
                whiteSpace: "nowrap",
                height: "36px",
              }}
              onClick={onClickSetPontosMapa}
              disabled={editavel}
            >
              <FontAwesomeIcon
                icon={faMagnifyingGlassLocation}
                style={{ color: editavel ? "rgba(0, 0, 0, 0.26)" : "white" }}
              />
            </BlueHoverButton>
          </Tooltip>
        </div>
        <div style={{ width: "100%" }}>
          <div style={{ height: "400px" }}>
            <Lista
              columns={columnsSolCompartilhamentoPonto(
                handleDelete,
                handleCheck,
                editavel
              )}
              rows={solCompartilhamentoPonto}
              setSelectedData={() => { }}
              onDblClick={() => { }}
              hideFooter={false}
              autoHeight={false}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ paddingTop: "20px" }}>
              <InputLabel
                sx={{
                  color: "#b8b8b8",
                  fontSize: "12px",
                  fontWeight: 600,
                }}
              >
                Qtde. pontos
              </InputLabel>
              <Controller
                name="qtdePontos"
                control={control}
                render={({ field }) => (
                  <FormControl variant="outlined" style={{ width: "160px" }}>
                    <WhiteInput
                      fullWidth
                      placeholder="Qtde. pontos"
                      type="number"
                      name="tdePontos"
                      id="qtde-pontos"
                      {...field}
                      readOnly={true}
                      onKeyDown={onKeyDown}
                      className={`${errors?.QtdePontos ? styles.campoComValorErrado : ""
                        }`}
                    />
                    {errors?.QtdePontos ? (
                      <HelperText text={errors?.QtdePontos?.message} />
                    ) : (
                      ""
                    )}
                  </FormControl>
                )}
              />
            </div>
            <div style={{ paddingTop: "20px" }}>
              {solCompartilhamentoPonto.length > 0 && (
                <div style={{ display: "flex", gap: "10px", marginTop: "16px" }}>
                  {!pontosMarcadosOcupacao && <BlueHoverButton
                    onClick={handleMarcarTodasTemOcupacoes}
                    disabled={editavel}
                    sx={{
                      background: "#8166F5",
                      color: "white",
                      borderRadius: "10px",
                      cursor: "pointer",
                      border: "none",
                      borderLeft: "none",
                      padding: "12px 40px",
                      "&:hover": {
                        background: "rgb(91, 74, 168)",
                        color: "#FFFFFF",
                        border: "none",
                        borderLeft: "none",
                        boxShadow: "none",
                      },
                    }}
                  >
                    <FontAwesomeIcon icon={faCheckDouble} />
                    <InputLabel
                      sx={{
                        color: "#fff",
                        fontSize: "12px",
                        fontWeight: 600,
                        marginLeft: "12px",
                        cursor: "pointer",
                      }}
                    >
                      Marcar todas as ocupações
                    </InputLabel>
                  </BlueHoverButton>}
                  {pontosMarcadosOcupacao && (
                    <BlueHoverButton
                      onClick={handleDesmarcarTodasTemOcupacoes}
                      disabled={editavel}
                      sx={{
                        background: "#8166F5",
                        color: "white",
                        borderRadius: "10px",
                        cursor: "pointer",
                        border: "none",
                        borderLeft: "none",
                        padding: "12px 40px",
                        "&:hover": {
                          background: "rgb(91, 74, 168)",
                          color: "#FFFFFF",
                          border: "none",
                          borderLeft: "none",
                          boxShadow: "none",
                        },
                      }}
                    >
                      <FontAwesomeIcon icon={faCheckDouble} />
                      <InputLabel
                        sx={{
                          color: "#fff",
                          fontSize: "12px",
                          fontWeight: 600,
                          marginLeft: "12px",
                          cursor: "pointer",
                        }}
                      >
                        Desmarcar todas as ocupações
                      </InputLabel>
                    </BlueHoverButton>
                  )}
                  <BlueHoverButton
                    onClick={handleRemoverTodosPontos}
                    disabled={editavel}
                    sx={{
                      background: "rgb(235, 63, 51)",
                      color: "white",
                      borderRadius: "10px",
                      cursor: "pointer",
                      border: "none",
                      borderLeft: "none",
                      padding: "12px 40px",
                      "&:hover": {
                        background: "rgb(201, 67, 57)",
                        color: "#FFFFFF",
                        border: "none",
                        borderLeft: "none",
                        boxShadow: "none",
                      },
                    }}
                  >
                    <FontAwesomeIcon icon={faTrashCan} />
                    <InputLabel
                      sx={{
                        color: "#fff",
                        fontSize: "12px",
                        fontWeight: 600,
                        marginLeft: "12px",
                        cursor: "pointer",
                      }}
                    >
                      Remover todos
                    </InputLabel>
                  </BlueHoverButton>
                </div>
              )}
            </div>
          </div>
        </div>
        <Dialog
          open={openDialogMessageClearMap}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          sx={{
            '& .MuiPaper-root': {
              backgroundColor: "#232323",
              color: "whitesmoke",
              padding: "20px",
              borderRadius: "10px",
              width: "400px"
            }
          }}
        >
          <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "bold", alignContent: "center", fontSize: "18px" }}>
            {"Atenção!"}
          </DialogTitle>
          <DialogContent id="alert-dialog-description" sx={{ fontSize: "14px" }}>
            Todos os pontos adicionados serão removidos do mapa. <strong>Deseja realmente limpar o mapa?</strong>
          </DialogContent>
          <DialogActions>
            <BlueHoverButton
              autoFocus
              onClick={handleLimparMapa}
            >
              Continuar
            </BlueHoverButton>
            <BlueHoverButton
              onClick={handleCloseDialog}>Cancelar</BlueHoverButton>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export { Pontos };
